import React from 'react';
import { Establishment } from '../../../../hooks/use-establishments';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';
import Table from './Table';

export type NonCode95DataEntry = {
	id: number;
	lastNameAndInsertion: string;
	firstName: string;
	initials: string;
	dateOfBirth: string;
	establishment: {
		id: number;
		name: string;
	};
};
type Props = {
	students: NonCode95DataEntry[];
	establishmentData: Establishment[];
};

const columnHelper = createColumnHelper<NonCode95DataEntry>();
const NonCode95Overview = ({ students, establishmentData }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() =>
			[
				columnHelper.accessor('lastNameAndInsertion', {
					header: t('employees.lastName'),
					enableColumnFilter: false,
				}),
				columnHelper.accessor('firstName', {
					header: t('employees.firstName'),
					enableColumnFilter: false,
				}),
				columnHelper.accessor('initials', {
					header: t('employees.initials'),
					enableColumnFilter: false,
				}),
				columnHelper.accessor('dateOfBirth', {
					header: t('employees.dateOfBirth'),
					enableColumnFilter: false,
				}),
			] as Array<AccessorKeyColumnDef<NonCode95DataEntry, unknown>>,
		[t],
	);

	return <Table data={students} columns={columns} establishmentData={establishmentData} />;
};

export default NonCode95Overview;
